import {init, captureException, captureMessage, ErrorBoundary} from "@sentry/react";

init({
    dsn: "https://ad19db56a9954295b425107b8d7941b0@o452185.ingest.sentry.io/5439236",

    integrations: [
        //
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // tracesSampleRate: 0.5,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/getsoapy.com\/api/
    ],

    allowUrls: [
        /https:\/\/((app|embed)\.)?getsoapy\.com/
    ],

});

export {
    ErrorBoundary,
    captureException,
    captureMessage,
}

import(/* webpackPreload: true, webpackChunkName: "sentry" */'./LazySentry');